<!--
 * @Author: 李鸿润
 * @Date: 2021-08-04 10:10:35
 * @LastEditTime: 2021-08-16 20:05:01
 * @LastEditors: Please set LastEditors
 * @Description: 车场报表展示
 * @FilePath: \hpss-ui\src\views\v4ward\car\carreport.vue
-->
<template>
    <div>
        <basic-container>
    <iframe
      width="100%"
      height="900px"
      :src="iframeUrl"
      id="reportFrame"
      frameborder="0"
    ></iframe>
        </basic-container>
    </div>
</template>


<script>
import { mapGetters } from 'vuex';
import urlSettings from '@/config/url-settings.js';
export default {
    computed: {
    ...mapGetters(['userInfo']),
  },
    data(){
        return {
            iframeUrl:'',
            selectForm:{},
            carParkList:[],
            deptId:'',
            userId:''
        }
    },
    methods:{
        initData(){
            this.deptId = this.userInfo.dept_id
            this.userId =this.userInfo.user_id
            let path 
             path =
            // urlSettings.VUE_APP_BASE_REPORT_URL +
            // urlSettings.VUE_APP_ENVIRONMENT +
            ' https://rpt-test.pms1.cn/webroot/decision/view/form?viewlet=pms_cjwy'+ 
             `/parking.cpt&deptId=(` + this.deptId +`)`
             
            this.iframeUrl = path
         
        },
        search(){
            
        }
    },
    created(){
        this.initData()
    }

}
</script>

<style>

</style>

